// src/utils/config.js
import defaultConfig from '../config/default.json';
import devConfig from '../config/dev.json';
import prodConfig from '../config/prod.json';

class Config {
  constructor() {
    this.env = process.env.REACT_APP_ENV || 'development';
    console.log(process.env.REACT_APP_ENV);
    this.config = this.loadConfig();
  }

  loadConfig() {
    let envConfig = {};

    switch (this.env) {
      case 'production':
        envConfig = prodConfig;
        break;
      case 'development':
        envConfig = devConfig;
        break;
      default:
        envConfig = devConfig;
    }

    return {
      ...defaultConfig,
      ...envConfig,
      apiUrl: process.env.REACT_APP_API_URL || envConfig.services.API_BASE_URL || defaultConfig.services.API_BASE_URL,
      apiKey: process.env.REACT_APP_API_KEY || envConfig.services.API_KEY || defaultConfig.services.API_KEY,
      appName: process.env.REACT_APP_NAME || envConfig.APPName || defaultConfig.APPName,
      environment: this.env,
    };
  }

  get(key) {
    return this.config[key];
  }

  getAll() {
    return this.config;
  }
}

const config = new Config();
export default config;